<template>
  <div>
    <b-card
      no-body
      class="card-custom">
      <b-card-body class="p-0">
        <b-embed
          type="iframe"
          aspect="16by9"
          class="rounded"
          src="http://172.16.20.68:3000/d/0hyIh0-Vk/vpn-microservice?orgId=1&refresh=10s"></b-embed>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'StatiscticsGrafana',
  data() {
    return {
      
    }
  },
  mounted() {
    
  },
}
</script>
